import { sellerApi } from '@core/api/httpClient'
import { profileEndpointPaths } from './profileEndpointPaths'
import type { ApiEnvelope, SellerProfileDto } from './contracts/profileContracts'
import type { SellerOwnerProfileDto } from './contracts/ownerProfileContracts'

export async function getSellerProfile(): Promise<SellerProfileDto> {
  const { data } = await sellerApi.get<ApiEnvelope<SellerProfileDto>>(
    profileEndpointPaths.SELLER_ME,
  )
  return data.data
}

export async function getSellerOwnerProfile(): Promise<SellerOwnerProfileDto> {
  const { data } = await sellerApi.get<ApiEnvelope<SellerOwnerProfileDto>>(
    profileEndpointPaths.SELLER_OWNER_PROFILE,
  )
  return data.data
}
